/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/envelope_open'
export default icon
